import React, {useState, useEffect, useRef} from 'react';
import ReactDOM from 'react-dom';
import './styles.css';
import LoaderLogoSoftwone from '_layout/assets/svg/Animaciones/logoSoftwone';
import Validaciones from '@renedelangel/helpers/lib/Validaciones';
import { rgxNombre } from 'helpers/regexp';
import PopUpAlert from '../PopUpAlerta';
import conektaHelper from 'helpers/conekta';
import { urlServidor } from 'helpers';
import FetchAPI from '@renedelangel/helpers/lib/FetchAPI';
import { useSelector } from 'react-redux';
import shopping from './images/shopping.png'
import errorImage from './images/error.png';
import bannerScrum from './images/GrayScrum.png';
import {
    avisoSoftwone,
    terminosSoftwone
} from '../../../../public/Pdf/Softwone/exportPDF';
import { useHistory } from 'react-router-dom';
import { addProductosConLicenciaPorUsuario } from '../../../../Mutations/ProductosConLicenciaPorUsuario';
import Encriptar from '@renedelangel/helpers/lib/Encriptar';
import moment from 'moment/moment';
import { RegistrarCuenta } from 'Mutations/DemoScrum';
import { solicitoDemoScrumOne } from 'Mutations/Usuarios/metodos';

const { GenerarToken } = Encriptar;

const {trim} = Validaciones;



export default function PopUpDemo({solicitudValida, propsSetOpenSolicitudDemo, propsSetValidarDemo,propsPaqueteSeleccionado}){

    const { usuario, token } = useSelector(state => state.login);
    const history = useHistory();
    const [procesoFinalizado, setProcesoFinalizado] = useState(false);

    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

    const clearState = {
        nameCard: "",
        cardNumber: "",
        expMonth: "",
        expYear: "",
        cvv: "",
        checkbox: false
    };

    const seedToken = "c29mdHdvbmVAc2VndW1leA==";
    const tokenTemporal = GenerarToken({
        data: { usuario: "temporal" },
        expiresIn: "1m",
        seed: seedToken
    });

    const [state, setState] = useState(clearState);
    const [alert, setAlert] = useState({
        mensaje: "",
        titulo: ""
    });
    const [openAlert, setOpenAlert] = useState(false);

    const [disabled, setDisabled] = useState(false);
    const [loading, setLoading] = useState(false);


    async function conektaGenerarToken() {
        setLoading(true);
        conektaHelper.initConekta();

        if (!rgxNombre.test(nameCard) || trim(nameCard) === '') {
            setAlert({
                mensaje: "Verifica el nombre del tarjetahabiente",
                titulo: "¡Error!"
            });
            setLoading(false);
            setOpenAlert(true);
            return;
        }

        if (!conektaHelper.validateCardNumber(state.cardNumber)) {
            setAlert({
                mensaje: "Verifique el número de la tarjeta",
                titulo: "¡Error!"
            });
            setLoading(false);
            setOpenAlert(true);
            return;
        }

        if (expMonth == "") {
            setAlert({
                mensaje: "Debe seleccionar un mes",
                titulo: "¡Error!"
            });
            setLoading(false);
            setOpenAlert(true);
            return;
        }

        if (expYear == "") {
            setAlert({
                mensaje: "Debe seleccionar un año",
                titulo: "¡Error!"
            });
            setLoading(false);
            setOpenAlert(true);
            return;
        }

        if (!conektaHelper.validateExpirationDate(expMonth, expYear)) {
            setAlert({
                mensaje: "Valida la vigencia del año y mes",
                titulo: "¡Error!"
            });
            setLoading(false);
            setOpenAlert(true);
            return;
        }

        if (!conektaHelper.validateCvc(cvv)) {
            setAlert({
                mensaje: "Debe registrar un cvv valido",
                titulo: "¡Error!"
            });
            setLoading(false);
            setOpenAlert(true);
            return;
        }


        if(!checkbox){
            setAlert({
                mensaje: "Es necesario aceptar los terminos y condiciones de Softwone",
                titulo: "Aceptar términos y condiciones"
            })
            setLoading(false);
            setOpenAlert(true);
            return;
        }

        conektaHelper.initConekta();
        let AuxVencimiento = [state.expMonth, state.expYear];
        conektaHelper.tokenize(
            state.cardNumber,
            state.nameCard,
            AuxVencimiento[0],
            AuxVencimiento[1],
            state.cvv,
            AgregarTarjeta,
            errorTokenConekta
        );
        ///Hasta aquí si se generó el token de conekta correctamente, se contnua en la función TokenConektaGenerado, sino se continua en el errorTokenConekta.
    }

    async function AgregarTarjeta(TokenConekta) {
        setDisabled(true);
        let resultado = await FetchAPI.send({
            url: `${urlServidor}/Conekta/AgregarTarjeta`,
            params: {
                usuarioID: JSON.stringify(usuario.usuarioID),
                tokenConekta: JSON.stringify(TokenConekta),
                state: JSON.stringify(state),
                datosUsuario: JSON.stringify({
                    nombre: usuario.nombre,
                    correo: usuario.correo
                })
            }
        });

        // setLoader(false);
        if (resultado.ok == true) {

            try{
            let auxRegistroCuenta = await addProductosConLicenciaPorUsuario({input: {
            usuarioID: usuario.usuarioID,
            productoID: parseInt(propsPaqueteSeleccionado.productoID),
            codigoProducto: propsPaqueteSeleccionado.codigoProducto,
            pagoActivo: 1,
            periodicidad: "MENSUAL",
            fechaContratacion: moment().format('YYYY-MM-DD'),
            fechaUltimoPagoRegistrado: moment().format('YYYY-MM-DD'),
            tarjetaAsociadaID: resultado.resultado.tarjetaID
            }}, token)

            let cuentaGenerada = await RegistrarCuenta({
                NombreCompleto: usuario.nombre,
                NombreUsuario: usuario.usuario,
                CorreoElectronico: usuario.correo,
                Password: "Password",
                CodigoProducto: auxRegistroCuenta.codigoProducto
            }, tokenTemporal);

            let auxUpdateUsuario = await solicitoDemoScrumOne({input:{usuarioID: usuario.usuarioID}}, token);
            setProcesoFinalizado(true);
            }catch({}){
                setLoading(false);
                setAlert({
                    titulo: "error",
                    mensaje:
                        "Ha ocurrido un error al generar la cuenta"
                });
                setOpenAlert(true);
                setDisabled(false);    
            }

            setLoading(false);
        } else {
            setLoading(false);
            setAlert({
                titulo: "error",
                mensaje:
                    "Ha ocurrido un error al registrar la tarjeta, vuelva a intentarlo"
            });
            setOpenAlert(true);
            setDisabled(false);
        }
    }

    function errorTokenConekta(token) {
        setLoading(false);
        setAlert({
            mensaje: 'Revisa tu información',
            title: "Problemas al generar el token"
        });
        setOpenAlert(true);
    }

    async function stop() {
        setState(clearState);
        await delay(3000);
        setOpenAlert(false);
    }

    function handleChange(e) {
        const { name, value } = e.target;
        setState(prevState => {
            return {
                ...prevState,
                [name]: value
            };
        });
    }

    let { nameCard, cardNumber, expMonth, expYear, cvv, checkbox } = state;
    





    return ReactDOM.createPortal(
    <>
    {
        solicitudValida ?


    <div className = 'cSolicitudDemo' onClick={() => {
        propsSetOpenSolicitudDemo(false);
        propsSetValidarDemo(false);
        }}>
            {
                !procesoFinalizado?
    <div className = 'iSolicitudDemo' onClick={e => {
                        e.stopPropagation();
                    }}>
    <div className='cImageSolicitudDemo'>
        <img src={shopping}/>
    </div>
    <div className='cTituloSolicitudDemo'>
    ¡Felicidades!, estas a unos pasos de adquirir tu prueba gratuita de <b>Scrum-One</b>.
    </div>
    <div className='cDescripcionSolicitudDemo'>
    Registra un método de pago y sigue disfrutando del acceso a la plataforma al finalizar tu periodo de prueba.
    </div>
    <div className='cDescripcionSolicitudDemo'>
    No se realizara ningun cobro hasta el final de tu prueba gratuita.
    </div>

    <div className='cFormDatosPago'>
    <div className="tituloAgregarTarjetas">
                        <h3>Datos de la tarjeta</h3>
                    </div>

                    <form className="formTarjetas">
                        <div className="contenedorNombreTarjeta">
                            <label htmlFor={"nameCard"}>
                                Nombre de tarjetahabiente
                            </label>
                            <input
                                id={"nameCard"}
                                placeholder="Nombre"
                                name="nameCard"
                                value={nameCard}
                                onChange={e => {
                                    handleChange(e);
                                }}
                            />
                        </div>
                        <div className="contenedorNumeroTarjeta">
                            <label htmlFor="numeroTarjetaID">
                                Número de tarjeta
                            </label>
                            <input
                                className="numeroTarjeta"
                                id="numeroTarjetaID"
                                type="tel"
                                inputMode="numeric"
                                pattern="[0-9\s]{13,19}"
                                autoComplete="cc-number"
                                maxLength="19"
                                placeholder="XXXX - XXXX - XXXX - XXXX"
                                name="cardNumber"
                                value={cardNumber}
                                onChange={e => {
                                    handleChange(e);
                                }}
                            />
                        </div>

                        <div className="agrupadorDatos">
                            <div className="contenedorFechaTarjeta">
                                <label>Fecha de vencimiento</label>
                                <div className="agrupadorFechas">
                                    <div className="agrupadorMesTarjeta">
                                        <select
                                            className="mesTarjeta"
                                            name="expMonth"
                                            value={expMonth}
                                            onChange={e => {
                                                handleChange(e);
                                            }}
                                        >
                                            <option value={""} disabled>
                                                {" "}
                                                Seleccione el mes
                                            </option>
                                            <option
                                                value={"01"}
                                                selected="selected"
                                            >
                                                01
                                            </option>
                                            <option value={"02"}>02</option>
                                            <option value={"03"}>03</option>
                                            <option value={"04"}>04</option>
                                            <option value={"05"}>05</option>
                                            <option value={"06"}>06</option>
                                            <option value={"07"}>07</option>
                                            <option value={"08"}>08</option>
                                            <option value={"09"}>09</option>
                                            <option value={"10"}>10</option>
                                            <option value={"11"}>11</option>
                                            <option value={"12"}>12</option>
                                        </select>
                                    </div>
                                    <div className="agrupadorYearTarjeta">
                                        <select
                                            className="yearTarjeta"
                                            name="expYear"
                                            value={expYear}
                                            onChange={e => {
                                                handleChange(e);
                                            }}
                                        >
                                            <option value={""} disabled>
                                                Seleccione el año
                                            </option>
                                            <option
                                                value={"22"}
                                                selected="selected"
                                            >
                                                2022
                                            </option>
                                            <option value={"23"}>2023</option>
                                            <option value={"24"}>2024</option>
                                            <option value={"25"}>2025</option>
                                            <option value={"26"}>2026</option>
                                            <option value={"27"}>2027</option>
                                            <option value={"28"}>2028</option>
                                            <option value={"29"}>2029</option>
                                            <option value={"30"}>2030</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                           
                        </div>

                        <div className="agrupadorCvv">
                                <label htmlFor="cvvTarjeta">Código de seguridad</label>
                                <input
                                    id="cvvTarjeta"
                                    className="cvvTarjeta"
                                    maxLength={3}
                                    placeholder="CVV"
                                    name="cvv"
                                    value={cvv}
                                    onChange={e => {
                                        handleChange(e);
                                    }}
                                />
                            </div>
                    </form>

                    <div className='c_agrupador_terminos_registro' style={{width: '90%'}}>
                    <div className="terminosCondicionesRegistrarse">
                        <input
                            disabled = {disabled}
                            id={"checkBoxRegistro"}
                            type="checkbox"
                            checked= {checkbox}
                            onClick={e => {
                                let { value, name } = e.target;
                                let aux = {
                                    target: {
                                        name: name,
                                        value:
                                            value == "true" ? true : false
                                    }
                                };

                                handleChange(aux);
                            }}
                            name="checkbox"
                            value = {!checkbox}
                        />
                        <label htmlFor={"checkBoxRegistro"}>
                           <h6 style={{color: 'black'}}> He leído y comprendido los &nbsp; <a href={terminosSoftwone} target="_blank">Términos y condiciones</a> &nbsp; de
                            Softwone.com</h6>
                        </label>
                    </div>
                    </div>

                    <button
                        onClick={() => {
                            conektaGenerarToken();
                        }}
                        className="buttonSubmitAddTarjeta"
                        disabled={disabled}
                    >
                        Confirmar
                    </button>
                </div>
            </div>:
            <div className = 'iSolicitudDemo' onClick={e => {
                e.stopPropagation();
            }}>
            <div className='cImageSolicitudDemo'>
            <img src={bannerScrum}/>
            </div>
            <div className='cTituloSolicitudDemo'>
            ¡Bienvenido!, se ha registrado con exito tu cuenta de prueba.
            </div>
            <div className='cDescripcionSolicitudDemo'>
            Ahora puedes realizar todos tus procesos siguiendo la metodología SCRUM en la mejor plataforma disponible. <br/> <br/>
            Espera un correo con un enlace para cambiar la contraseña de tu usuario. <br/> <br/>
            *Si no encuentras el correo puedes contactarnos en la sección de Contacto
            </div>
            <div className='cButtonContactoSolicitudDemo' onClick={() => {history.push('/contact')}}>
            Ir a Contacto
            </div>
            <div className='cButtonContactoSolicitudDemo' onClick={() => {propsSetOpenSolicitudDemo(false);
        propsSetValidarDemo(false);}}>
            Finalizado
            </div>
            </div>
            }
    </div>
    :
    <div className = 'cSolicitudDemo' onClick={() => {
        propsSetOpenSolicitudDemo(false);
        propsSetValidarDemo(false)
        }}>
    <div className = 'iSolicitudDemo' onClick={e => {
                        e.stopPropagation();
                    }}>
    <div className='cImageSolicitudDemo'>
        <img src={errorImage}/>
    </div>
    <div className='cTituloSolicitudDemo'>
        Detectamos un detalle con esta cuenta
    </div>
    <div className='cDescripcionSolicitudDemo'>
        No se puede solicitar una prueba, ¿ya has comprado o solicitado una prueba con anterioridad?. <br/>
        Si crees que es un error puedes contactarnos en la sección de Contacto
    </div>
    <div className='cButtonContactoSolicitudDemo' onClick={() => {history.push('/contact')}}>
        Ir a Contacto
    </div>
    </div>
    </div>
    }

    {openAlert ? (
                <PopUpAlert
                    mensaje={alert.mensaje}
                    titulo={alert.titulo}
                    open={setOpenAlert}
                    showAceptar={true}
                />
            ) : (
                <></>
            )}

            {loading ? <LoaderLogoSoftwone /> : <></>}
    </>, document.getElementById('login')
    )



}